import(/* webpackMode: "eager" */ "/var/www/vietthien.com/src/app/[locale]/tin-tuc/nong-san/page.tsx");
